import { Color } from '@diritto/common/style/color';
import { NewIconProps } from '@diritto/common/style/icon';
import { twMerge } from 'tailwind-merge';

export const ReplyBlankIcon = ({ className, color = Color.Gray400 }: NewIconProps) => (
  <svg
    className={twMerge('size-[11px]', className)}
    width="100%"
    height="100%"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="-1 -1 13 13">
    <path
      d="M4.25 11.833a.583.583 0 01-.583-.583V9.5H1.333A1.167 1.167 0 01.167 8.333v-7C.167.686.692.167 1.333.167h9.334a1.166 1.166 0 011.166 1.166v7A1.167 1.167 0 0110.667 9.5H7.108L4.95 11.664a.594.594 0 01-.408.17H4.25zm.583-3.5v1.797L6.63 8.333h4.037v-7H1.333v7h3.5z"
      fill={color}
    />
  </svg>
);
